import Viewer from "../components/Scene/viewer";
import Data, { Truck, Simulation, DialogType } from "./data";
import { REMOTE_SIMULATION, MANUAL_SIMULATION, FIRST_PERSON_SIMULATION } from "constants/sumilationConstants";

export const SET_TRUCK = 'SET_TRUCK'
export const SET_DATA = 'SET_DATA'
export const LOAD_DATA_REQUEST = 'LOAD_DATA_REQUEST'
export const LOAD_DATA_FAIL = 'LOAD_DATA_FAIL'
export const LOAD_DATA_SUCCESS = 'LOAD_DATA_SUCCESS'
export const SET_VIEWER_API = 'SET_VIEWER_API'
export const SET_SIMULATION_SELECT = 'SET_SIMULATION_SELECT' 
export const SET_ACTIVE_SIMULATION = 'SET_ACTIVE_SIMULATION'
export const SET_ACTIVE_SIMULATION_STEP = 'SET_ACTIVE_SIMULATION_STEP'
export const SET_ACTIVE_SIMULATION_TYPE = 'SET_ACTIVE_SIMULATION_TYPE'
export const SET_SIMULATION_SIDE_ACTIVE = 'SET_SIMULATION_SIDE_ACTIVE'
export const END_ACTIVE_SIMULATION = 'END_ACTIVE_SIMULATION'
export const RESTART_SIMULATION = 'RESTART_SIMULATION'
export const SET_POSITION_READY = 'SET_POSITION_READY' 
export const SET_AVSP = 'SET_AVSP' 
export const GO_TO_NEXT_SIMULATION = 'GO_TO_NEXT_SIMULATION' 
export const SET_CONTENT_OPENED = 'SET_CONTENT_OPENED' 
export const SET_NEXT_SIM_STEP = 'SET_NEXT_SIM_STEP' 
export type SimulationType = typeof REMOTE_SIMULATION | typeof MANUAL_SIMULATION | typeof FIRST_PERSON_SIMULATION | string

interface goToNextSimulation {
  type: typeof GO_TO_NEXT_SIMULATION,
}
interface setNextSimStep {
  type: typeof SET_NEXT_SIM_STEP,
}

interface setAVSP {
  type: typeof SET_AVSP,
  payload: Boolean
}

interface SetPositionReady {
  type: typeof SET_POSITION_READY,
  payload: Boolean
}

interface SetContentOpened {
  type: typeof SET_CONTENT_OPENED,
  payload: Boolean
}

interface LoadDataFail {
  type: typeof LOAD_DATA_FAIL,
}

interface endActiveSimulation {
  type: typeof END_ACTIVE_SIMULATION
}

interface setSimulationSelect {
  type: typeof SET_SIMULATION_SELECT,
  simulationSelectActive: Boolean
}

interface setSimulationSidePanelActive {
  type: typeof SET_SIMULATION_SIDE_ACTIVE,
  payload: Boolean
}

interface SetViewerApi {
  type: typeof SET_VIEWER_API,
  viewerApi: Viewer
}

interface restartActiveSimulation {
  type: typeof RESTART_SIMULATION
}

interface SetActiveSimulationStep {
  type: typeof SET_ACTIVE_SIMULATION_STEP,
  payload: number
}

interface SetActiveSimulationType {
  type: typeof SET_ACTIVE_SIMULATION_TYPE,
  payload: SimulationType
}

interface LoadDataSuccess {
  type: typeof LOAD_DATA_SUCCESS,
  payload: Data
}

interface LoadDataRequest {
  type: typeof LOAD_DATA_REQUEST,
}

interface SetTruck {
  type: typeof SET_TRUCK,
  payload: Truck,
}

interface setActiveSimulation {
  type: typeof SET_ACTIVE_SIMULATION,
  payload: Simulation | undefined
}

export interface AppState {
  data?: Data,
  truck?: Truck,
  loading: Boolean,
  error: Boolean,
  webglError: Boolean,
  viewerApi?: Viewer,
  sceneLoading: Boolean,
  sceneLoadingProgress: Number,
  simulationSelectActive: Boolean,
  activeSimulation?: Simulation,
  activeSimulationType?: SimulationType,
  activeSimulationStep: number,
  simulationSidePanelActive: Boolean,
  activeDialogType: DialogType,
  positionReady: Boolean,
  lastActiveSimulation?: Simulation,
  restartKey?: any,
  afterLeverAnimationProgress: Boolean,
  contentOpened: Boolean
}

export type AppTypes = 
  | SetTruck 
  | setSimulationSidePanelActive 
  | setActiveSimulation 
  | LoadDataRequest 
  | LoadDataFail 
  | LoadDataSuccess 
  | SetViewerApi 
  | setSimulationSelect
  | goToNextSimulation
  | SetActiveSimulationType
  | SetActiveSimulationStep
  | endActiveSimulation
  | restartActiveSimulation
  | setAVSP
  | SetPositionReady
  | SetContentOpened
  | setNextSimStep